type StatusDotColor =
  | "gold"
  | "green"
  | "red"
  | "light-red"
  | "blue"
  | "orange"
  | "purple"
  | "light-grey"
  | "grey"
  | "dark-grey";

const dotColorClasses: Record<StatusDotColor, string> = {
  gold: "bg-gold",
  green: "bg-green",
  red: "bg-red",
  "light-red": "bg-red/40",
  blue: "bg-blue",
  orange: "bg-orange",
  purple: "bg-purple",
  "light-grey": "bg-foreground/15",
  grey: "bg-foreground/30",
  "dark-grey": "bg-foreground/60",
};

type StatusDotLabelSize = "xs" | "sm" | "base" | "lg";

const labelSizeClasses: Record<StatusDotLabelSize, string> = {
  xs: "text-xs",
  sm: "text-sm",
  base: "text-base",
  lg: "text-lg",
};

export type { StatusDotColor };

interface StatusDotProps {
  color: StatusDotColor;
  label?: string | undefined;
  /** When true, the dot pulses to indicate live/active state. */
  pulse?: boolean | undefined;
  /** Controls the label text size. Defaults to `sm`. */
  labelSize?: StatusDotLabelSize | undefined;
}

export function StatusDot({
  color,
  label,
  pulse,
  labelSize = "sm",
}: StatusDotProps) {
  const dot = (
    <span
      className={`inline-block h-2.5 w-2.5 rounded-full ${dotColorClasses[color]} ${pulse ? "animate-pulse" : ""}`}
    />
  );

  if (!label) return dot;

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-bold text-foreground ${labelSizeClasses[labelSize]}`}
    >
      {dot}
      {label}
    </span>
  );
}
